// extracted by mini-css-extract-plugin
export default {"minibagFooter":"LRIejtP EVhxZk8 leavesden2"};